import { useCallback } from 'react';
import create from 'zustand';
import { persist } from 'zustand/middleware';
import { STORE_PREFIX } from 'constants/globals';

const useStore = create(
  persist(
    set => ({
      loading: false,
      isProfessional: false,
      sidebarClose: false,
      sidebarVoiceMenu: 1,
      siderAdminVoiceMenu: 1,
      requestedLocation: null,
      activeTabLevel: 1,
      // Attività aperta in CreateInspection.jsx, sincronizzata via effetto:
      // `undefined` finché non risolve (issue #1021, 2026-09-28 — usata dal
      // Sidebar per nascondere il pulsante "Guida Interattiva" in view su
      // un'attività L3, qualunque sia la tab attiva).
      activeInspectionIsL3Activity: undefined,
      showLoader: () => set(() => ({ loading: true })),
      hideLoader: () => set(() => ({ loading: false })),
    }),
    {
      name: `${STORE_PREFIX}global`,
      getStorage: () => sessionStorage,
      partialize: state =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              !['activeTabLevel', 'activeInspectionIsL3Activity'].includes(
                key
              )
          )
        ),
    }
  )
);

const useGlobalSelector = () => useStore(useCallback(state => state, []));

export { useGlobalSelector, useStore as useGlobalStore };
